import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '../../../utils/no-whitespace.validator';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-forgotpassword',
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule,MatProgressSpinnerModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotpasswordComponent {
  // loginForm: FormGroup;
  showInvalidEmailMessage = false;
  forgotPasswordForm: FormGroup;
  responseMessage: string | null = null;
  errorMessage: string | null = null;
  isLoading: boolean = false;
  isLoggedIn = false;
  isSubmitClicked = signal<boolean>(false);

  constructor(private fb: FormBuilder, private router : Router,private authService : AuthService) {
    this.forgotPasswordForm = this.fb.group({
      mailId: ['', [Validators.required, noWhitespaceValidator, Validators.email, Validators.maxLength(320)]]
    });
  }

  ngOnInit() {
    
  }

  onForgotPassword() {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    // this.isLoading = true;
    // this.errorMessage = null

    const { mailId } = this.forgotPasswordForm.value;
    

    sessionStorage.setItem('email', mailId);

    this.authService.forgotPassword(mailId).subscribe({
      next: (response) => {
        this.isSubmitClicked.set(true);
        this.authService.setLoading(false)
        this.responseMessage = "If the submitted email is found, a password reset email will be sent to your inbox"; 
        this.showInvalidEmailMessage = false;
        this.errorMessage = '';
        this.forgotPasswordForm.disable();
      },
      error: (error) => {
        this.isSubmitClicked.set(true);
        this.forgotPasswordForm.disable();
        console.log("error",error);        
        this.responseMessage = "If the submitted email is found, a password reset email will be sent to your inbox";
        this.authService.setLoading(false)
        //  let errorMessage = "Something went wrong. Please try again.";
        // try {
        //   const parsedError = JSON.parse(error.error);
        //   errorMessage = parsedError.message || errorMessage;
        // } catch (e) {
        //   console.log("Error message is not JSON formatted.");
        // }
    
        // this.errorMessage = errorMessage;
       
        this.showInvalidEmailMessage = true;
      }
    });
  }

  navigate(){
    
    this.router.navigate(['/login'])

  }

}
